var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoptdesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202,
    height: 202,
    viewBox: "0 0 202 202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_135459",
    "data-name": "Group 135459",
    transform: "translate(-973 -690)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135458",
    "data-name": "Group 135458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135383",
    "data-name": "Group 135383",
    transform: "translate(842 39)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15500",
    "data-name": "Ellipse 15500",
    cx: 101,
    cy: 101,
    r: 101,
    transform: "translate(131 651)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "concept",
    transform: "translate(1001.016 708.267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135457",
    "data-name": "Group 135457",
    transform: "translate(12.482 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135455",
    "data-name": "Group 135455",
    transform: "translate(2.551 2.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135452",
    "data-name": "Group 135452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135448",
    "data-name": "Group 135448",
    transform: "translate(0 15.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135447",
    "data-name": "Group 135447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135446",
    "data-name": "Group 135446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135445",
    "data-name": "Group 135445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505699",
    "data-name": "Path 505699",
    d: "M170.431,205.711H31.877a11.643,11.643,0,0,1-11.894-11.375V87.683H170.431a5.828,5.828,0,0,1,5.953,5.693V200.017A5.827,5.827,0,0,1,170.431,205.711Z",
    transform: "translate(-19.983 -75.492)",
    fill: "#f2f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505700",
    "data-name": "Path 505700",
    d: "M170.431,87.683H154.619V189.84a5.952,5.952,0,0,1-6.08,5.815H31.877A11.643,11.643,0,0,1,19.983,184.28v10.056a11.643,11.643,0,0,0,11.894,11.375H170.431a5.828,5.828,0,0,0,5.953-5.693V93.376A5.827,5.827,0,0,0,170.431,87.683Z",
    transform: "translate(-19.983 -75.492)",
    fill: "#e2f4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_135444",
    "data-name": "Group 135444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505701",
    "data-name": "Path 505701",
    d: "M19.983,63.19V169.839c0-6.274,5.458-11.361,12.191-11.361h9.782a4.1,4.1,0,0,0,4.239-3.95V55.78a4.1,4.1,0,0,0-4.239-3.95H32.174c-6.733,0-12.191,5.086-12.191,11.36Z",
    transform: "translate(-19.983 -51.83)",
    fill: "#4a80aa"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135451",
    "data-name": "Group 135451",
    transform: "translate(112.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135449",
    "data-name": "Group 135449"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505702",
    "data-name": "Path 505702",
    d: "M363.815,96.186V202.139a14.087,14.087,0,0,0,.791,4.647l5.916,16.945a4.217,4.217,0,0,0,7.842,0l5.916-16.945a14.09,14.09,0,0,0,.791-4.647V96.186Z",
    transform: "translate(-363.815 -66.03)",
    fill: "#e28086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505703",
    "data-name": "Path 505703",
    d: "M385.071,31.874V18.128a10.628,10.628,0,1,0-21.255,0V31.874h21.255Z",
    transform: "translate(-363.816 -7.5)",
    fill: "#5b8eb7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_135450",
    "data-name": "Group 135450",
    transform: "translate(0 134.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505704",
    "data-name": "Path 505704",
    d: "M363.815,428.436H385.07a15.923,15.923,0,0,1-.791,4.955l-5.916,18.067a4.126,4.126,0,0,1-7.842,0l-5.916-18.067A15.923,15.923,0,0,1,363.815,428.436Z",
    transform: "translate(-363.815 -428.436)",
    fill: "#365e7d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_505705",
    "data-name": "Path 505705",
    d: "M363.815,70.408H385.07V82.156H363.815Z",
    transform: "translate(-363.815 -49.018)",
    fill: "#eab14d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135454",
    "data-name": "Group 135454",
    transform: "translate(41.753 46.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135453",
    "data-name": "Group 135453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505706",
    "data-name": "Path 505706",
    d: "M206.965,205.682V176.7a4.405,4.405,0,0,0-2.2-3.815l-25.1-14.494a4.405,4.405,0,0,0-4.405,0l-25.1,14.494a4.405,4.405,0,0,0-2.2,3.815v28.987a4.4,4.4,0,0,0,2.2,3.815l25.1,14.494a4.405,4.405,0,0,0,4.405,0l25.1-14.494A4.406,4.406,0,0,0,206.965,205.682Z",
    transform: "translate(-147.948 -157.796)",
    fill: "#bed8fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505707",
    "data-name": "Path 505707",
    d: "M178.6,191.188l28.918-16.7a4.4,4.4,0,0,0-1.612-1.612l-25.1-14.494a4.405,4.405,0,0,0-4.405,0l-25.1,14.494a4.4,4.4,0,0,0-1.612,1.612Z",
    transform: "translate(-149.092 -157.795)",
    fill: "#9dc6fb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135456",
    "data-name": "Group 135456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505708",
    "data-name": "Path 505708",
    d: "M165.539,25.913H152.2V12.525a12.856,12.856,0,0,0-25.7,0V25.913H43.019V20.779A6.546,6.546,0,0,0,36.4,14.326h-9.54A14.213,14.213,0,0,0,12.482,28.337V137.115A14.228,14.228,0,0,0,26.873,151.14H129.817l3.345,9.955a6.566,6.566,0,0,0,12.375,0l3.345-9.956h16.657a8.35,8.35,0,0,0,8.445-8.231V34.144a8.349,8.349,0,0,0-8.445-8.231ZM131.472,136.036V36.344h5.391v99.692h-5.391Zm0-104.54V25.178h15.755V31.5Zm7.878-26.648a7.788,7.788,0,0,1,7.878,7.677V20.33H131.472V12.525a7.788,7.788,0,0,1,7.878-7.677ZM17.456,28.337a9.3,9.3,0,0,1,9.4-9.163H36.4a1.628,1.628,0,0,1,1.647,1.6V121.5a1.628,1.628,0,0,1-1.647,1.6h-9.54a14.535,14.535,0,0,0-9.4,3.42Zm9.417,117.955a9.31,9.31,0,0,1-9.417-9.178v0a9.3,9.3,0,0,1,9.4-9.163H36.4A6.546,6.546,0,0,0,43.02,121.5V30.761H126.5v107.7a17.123,17.123,0,0,0,.894,5.463l.8,2.369Zm113.936,13.3a1.549,1.549,0,0,1-2.92,0c-.291-.855-5.952-17.568-6.178-18.7h15.276c-.225,1.125-5.871,17.8-6.178,18.7Zm28.2-16.678a3.432,3.432,0,0,1-3.471,3.383H150.511l.8-2.369a17.122,17.122,0,0,0,.894-5.463V57.768a2.488,2.488,0,0,0-4.974,0v78.268h-5.391V36.344h5.391V46.437a2.488,2.488,0,0,0,4.974,0V30.761h13.338a3.432,3.432,0,0,1,3.471,3.383Z",
    transform: "translate(-12.482 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505709",
    "data-name": "Path 505709",
    d: "M201.085,165.727l-25.1-14.494a6.975,6.975,0,0,0-6.955,0l-25.1,14.494a6.975,6.975,0,0,0-3.478,6.023v9.207a2.55,2.55,0,0,0,5.1,0v-7.333l24.408,14.092V215.9l-23.481-13.557a1.86,1.86,0,0,1-.928-1.606v-7.859a2.55,2.55,0,0,0-5.1,0v7.859a6.974,6.974,0,0,0,3.478,6.023l25.1,14.494a6.975,6.975,0,0,0,6.955,0l25.1-14.494a6.974,6.974,0,0,0,3.478-6.024V171.749A6.974,6.974,0,0,0,201.085,165.727Zm-29.509-10.076a1.86,1.86,0,0,1,1.855,0l23.481,13.557L172.5,183.3,148.1,169.207Zm26.959,46.693L175.054,215.9V187.716l24.408-14.092v27.113A1.859,1.859,0,0,1,198.535,202.344Z",
    transform: "translate(-98.693 -103.511)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoptdesign);
export default __webpack_public_path__ + "static/media/coptdesign.e847580a9ab230dfc149e6e45789446d.svg";
export { ForwardRef as ReactComponent };